// extracted by mini-css-extract-plugin
export var wordContainer = "_oj-0";